import { isIOS } from 'react-device-detect'

export const isRealIOSDevice = isIOS && window.innerHeight !== window.screen.height

export const fullHeight = isRealIOSDevice
  ? { height: '-webkit-fill-available', marginTop: '-83px' }
  : {}

export const fullHeightContainer = isRealIOSDevice ? { paddingTop: '83px' } : {}

export const backdropFilter = backdropFilter => ({
  backdropFilter,
  WebkitBackdropFilter: backdropFilter,
})
